import { TWhoami } from '@/types/trpc.types';
import { create } from 'zustand'
import { persist, PersistOptions } from 'zustand/middleware'

interface UserStore {
    user: TWhoami | null;
    setUser: (user: TWhoami | null) => void;
    logout: () => void;
}

export const useUserStore = create<UserStore>()(
    persist<UserStore, [], [], PersistOptions<UserStore>>(
      (set) => ({
        user: null,
        setUser: (user) => set({ user }),
        logout: () => set({ user: null }),
      }),
      {
        name: 'user-store',
      }
    )
)

// const user = useUserStore((state) => state.user)
// useUserStore.getState().setUser({ id: '1', name: 'John', token: 'abc123' })
